import React from 'react';
import { ArrowRightIcon, LockIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  id?: string;
  showMeta?: boolean;
  meta?: string;
};
export function CtaButton({
  label,
  id,
  showMeta = true,
  meta = 'Immediate digital access · One-time payment · 7-Day Guarantee'
}: CtaButtonProps) {
  return <div className="flex w-full flex-col items-center" data-id="element-108" data-mp="qkk5yr8m36yj">
      <a id={id} href={CHECKOUT_URL} className="group flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center font-sans text-[15px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_6px_0_#0e6b31] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-cta-dark active:translate-y-1 active:shadow-[0_2px_0_#0e6b31] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold sm:text-lg" data-id="element-109" data-mp="qizbt2q7lq17">
        <span data-id="element-110" data-mp="15bay60e48826">{label}</span>
        <ArrowRightIcon aria-hidden="true" className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-111" data-mp="35x5xti7dww42" />
      </a>
      {showMeta && <p className="mt-4 flex max-w-md items-start justify-center gap-1.5 text-center text-[13px] leading-snug text-ink-muted" data-id="element-112" data-mp="3ey41u0htp3mn">
          <LockIcon aria-hidden="true" className="mt-0.5 h-3.5 w-3.5 shrink-0" data-id="element-113" data-mp="3jxyry1trxp6n" />
          <span data-id="element-114" data-mp="3owjvob88iqzu">{meta}</span>
        </p>}
    </div>;
}